import React, { useEffect, useState } from 'react'

import { TableRow, TableCell } from 'components/Table'

import { Box, Typography, IconButton, makeStyles } from '@material-ui/core'

import { ArrowRight as ArrowIcon, Star as StarIcon } from 'react-feather'

import useAuth from 'hooks/useAuth'

import useSnackbar from 'hooks/useSnackbar'

import { AvatarIcon } from './components'
import InfiniteScrollList from '../InfiniteScrollList'

import styles from './styles'

import helpers from 'helpers'

import * as service from 'service'

const useStyles = makeStyles(styles)

const TableRowCompany = ({
  userCompany,
  isFavorite,
  favoriteId,
  onFavoriteChange,
  onBeforeSelect,
  ...rest
}) => {
  const classes = useStyles()
  const auth = useAuth()
  const snackbar = useSnackbar()
  const [currentFavoriteId, setCurrentFavoriteId] = useState(favoriteId ?? null)
  const [isSelecting, setIsSelecting] = useState(false)

  useEffect(() => {
    setCurrentFavoriteId(favoriteId ?? null)
  }, [favoriteId])

  const companyDocument = helpers.company.documentType(userCompany?.company)

  const handleClick = async () => {
    setIsSelecting(true)
    if (onBeforeSelect) onBeforeSelect()
    try {
      const response = await service.dponet.usersCompanies.selectCompany(
        userCompany.id,
      )

      const authToken = response?.data?.authToken
      const cookieToken = response?.data?.cookieToken

      if (!authToken) {
        setIsSelecting(false)
        return snackbar.open({
          message:
            'Ocorreu um erro ao acessar a empresa! Verifique se você ainda pertence à essa empresa e tente novamente',
          variant: 'error',
        })
      }

      service.dponet.auth.setToken(authToken)
      await service.cookies.auth.login(cookieToken)

      auth.loadDataWithAnimation()
    } catch (error) {
      setIsSelecting(false)
      snackbar.open({
        message: 'Ocorreu um erro ao selecionar empresa! Tente novamente',
        variant: 'error',
      })
    }
  }

  const handleFavorite = async (e) => {
    e.stopPropagation()
    try {
      if (currentFavoriteId) {
        await service.dponet.companyFavorites.destroy({
          companyFavoriteId: currentFavoriteId,
        })
        setCurrentFavoriteId(null)
        onFavoriteChange(userCompany.id, false)
      } else {
        const response = await service.dponet.companyFavorites.create({
          favoritableId: userCompany?.company?.id,
          favoritableType: 'Company',
        })
        const newFavoriteId = response?.data?.companyFavorite?.id
        setCurrentFavoriteId(newFavoriteId)
        onFavoriteChange(userCompany.id, true)
      }
    } catch (error) {
      snackbar.open({
        message: 'Ocorreu um erro ao atualizar favorito! Tente novamente',
        variant: 'error',
      })
    }
  }

  useEffect(() => {
    const redirectTo = sessionStorage.getItem('redirectTo')
    const companyId = Number(sessionStorage.getItem('companyId'))

    if (redirectTo && companyId === userCompany?.company?.id) handleClick()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userCompany.id])

  return (
    <TableRow
      className={classes.tableRow}
      pointer
      onClick={handleClick}
      {...rest}
    >
      <TableCell style={{ width: '100%', maxWidth: 0, overflow: 'hidden' }}>
        <Box display="flex" alignItems="center">
          <AvatarIcon
            company={userCompany.company}
            clientPortalTheme={userCompany.clientPortalTheme}
          />
          <Box ml={1} minWidth={0} overflow="hidden">
            <Typography noWrap>{userCompany?.company?.name}</Typography>
            <Typography noWrap className={classes.document}>
              {companyDocument}
            </Typography>
          </Box>
        </Box>
      </TableCell>
      <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
        <IconButton onClick={handleFavorite}>
          <StarIcon
            className={isFavorite ? classes.starActive : classes.starInactive}
            fill={isFavorite ? 'currentColor' : 'none'}
          />
        </IconButton>
        <IconButton
          onClick={(event) => {
            event.stopPropagation()
            handleClick()
          }}
          disabled={isSelecting}
        >
          <ArrowIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

const ListCompanies = ({
  usersCompanies,
  onLoadMore,
  isLoadingMore,
  onBeforeSelect,
}) => {
  const classes = useStyles()

  return (
    <InfiniteScrollList
      items={usersCompanies}
      onLoadMore={onLoadMore}
      scrollbarClassName={classes.perfectScrollbar}
      isLoadingMore={isLoadingMore}
      renderRow={(item, isFavorite, onFavoriteChange) => (
        <TableRowCompany
          key={item.id}
          userCompany={item}
          isFavorite={isFavorite}
          favoriteId={item.favoriteId}
          onFavoriteChange={onFavoriteChange}
          onBeforeSelect={onBeforeSelect}
        />
      )}
    />
  )
}

export default ListCompanies
